module.exports = __webpack_public_path__ + "img/vip_icon.26ae1a1f.png";